import { useDispatch } from "react-redux";
import { resetFilters, setFilter } from "..";

export const useFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setFilter({ key, value }));
  const clearFilters = () => dispatch(resetFilters()); 

  return { updateFilter, clearFilters };
};
